<template>
  <div class="dashboard__view bulk__page__content">
    <div v-if="error === ''">
      <div @click="downloadSample" class="bulk__header_right">
        <p>Download Sample Excel File</p>
      </div>
      <div class="bulk">
        <div class="bulk__icon">
          <svg
            width="47"
            height="60"
            viewBox="0 0 47 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.1908 0H2.3407C1.05012 0 0 1.05 0 2.3407V46.817C0 48.1077 1.05 49.1577 2.3407 49.1577H4.7093C4.87172 49.1577 5.02676 49.0903 5.13762 48.9716L41.4072 10.1261C41.5084 10.0175 41.5648 9.87457 41.5648 9.72621V2.37398C41.5649 1.065 40.4999 0 39.1908 0V0Z"
              fill="#FF6986"
            />
            <path
              d="M46.3105 14.4715V50.918C46.3105 52.2094 45.2605 53.2594 43.9703 53.2594H6.46445C5.17305 53.2594 4.12305 52.2094 4.12305 50.918V6.73477C4.12305 5.44453 5.17305 4.39453 6.46445 4.39453H36.2324L37.3152 5.47734L46.3105 14.4715Z"
              fill="#FFDADB"
            />
            <path
              d="M46.3105 14.4712V50.9177C46.3105 52.2091 45.2605 53.2591 43.9703 53.2591H6.46445C5.17305 53.2591 4.12305 52.2091 4.12305 50.9177V50.3294H41.541C42.8477 50.3294 43.907 49.27 43.907 47.9622V14.4712L37.3152 5.47705L46.3105 14.4712Z"
              fill="#B4D2D7"
            />
            <path
              d="M46.3105 14.4715H43.907L37.0035 14.4703C36.5781 14.4703 36.2324 14.1258 36.2324 13.6992V4.39453C36.3883 4.39453 36.5371 4.45547 36.6473 4.56562L46.1395 14.0578C46.2496 14.168 46.3105 14.3168 46.3105 14.4715Z"
              fill="white"
            />
            <path
              d="M46.3105 14.4715H43.907L36.6472 4.56567L46.1394 14.0579C46.2496 14.168 46.3105 14.3168 46.3105 14.4715Z"
              fill="white"
            />
            <path
              d="M14.7258 22.3191H35.7518C36.2372 22.3191 36.6308 21.9257 36.6308 21.4402C36.6308 20.9547 36.2372 20.5613 35.7518 20.5613H14.7258C14.2404 20.5613 13.8469 20.9547 13.8469 21.4402C13.8469 21.9257 14.2404 22.3191 14.7258 22.3191Z"
              fill="white"
            />
            <path
              d="M35.7518 25.7449H14.7258C14.2404 25.7449 13.8469 26.1383 13.8469 26.6238C13.8469 27.1093 14.2404 27.5027 14.7258 27.5027H35.7518C36.2372 27.5027 36.6308 27.1093 36.6308 26.6238C36.6308 26.1383 36.2372 25.7449 35.7518 25.7449Z"
              fill="white"
            />
            <path
              d="M35.7518 31.0312H31.5979C31.1125 31.0312 30.719 31.4246 30.719 31.9102C30.719 32.3957 31.1125 32.7891 31.5979 32.7891H35.7518C36.2372 32.7891 36.6308 32.3957 36.6308 31.9102C36.6308 31.4246 36.2372 31.0312 35.7518 31.0312Z"
              fill="white"
            />
            <path
              d="M27.4615 31.0312H14.7258C14.2404 31.0312 13.8469 31.4246 13.8469 31.9102C13.8469 32.3957 14.2404 32.7891 14.7258 32.7891H27.4615C27.9469 32.7891 28.3404 32.3957 28.3404 31.9102C28.3404 31.4246 27.9469 31.0312 27.4615 31.0312Z"
              fill="white"
            />
            <path
              d="M36.2783 48.9622C36.2783 55.0477 31.326 60 25.2393 60C24.7635 60 24.2947 59.9696 23.8354 59.911H23.8307C18.4061 59.2161 14.2002 54.5708 14.2002 48.9622C14.2002 43.3524 18.4061 38.7071 23.8307 38.0122H23.8354C24.2947 37.9536 24.7635 37.9231 25.2393 37.9231C31.326 37.9231 36.2783 42.8754 36.2783 48.9622Z"
              fill="#FF6986"
            />
            <path
              d="M36.2782 48.9622C36.2782 55.0477 31.3258 60 25.2391 60C24.7633 60 24.2946 59.9696 23.8352 59.911C29.2598 59.2161 33.4657 54.5708 33.4657 48.9622C33.4657 43.3524 29.2598 38.7071 23.8352 38.0122C24.2946 37.9536 24.7633 37.9231 25.2391 37.9231C31.3258 37.9231 36.2782 42.8754 36.2782 48.9622Z"
              fill="#EA3487"
            />
            <path
              d="M29.704 48.117C29.3607 48.4603 28.8042 48.4602 28.4611 48.1171L26.118 45.7741V54.2709C26.118 54.7564 25.7245 55.1498 25.2391 55.1498C24.7537 55.1498 24.3602 54.7564 24.3602 54.2709V45.7741L22.0172 48.1171C21.6739 48.4602 21.1174 48.4603 20.7743 48.117C20.431 47.7737 20.431 47.2172 20.7743 46.8741L24.6177 43.0308C24.7892 42.8592 25.0142 42.7734 25.2391 42.7734C25.464 42.7734 25.689 42.8592 25.8606 43.0308L29.704 46.8741C30.0472 47.2172 30.0472 47.7737 29.704 48.117Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="bulk__text" v-if="bulkFile.filename !== ''">
          {{ bulkFile.filename }}&nbsp;
          <svg
            class="cr-pointer"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="resetData"
          >
            <path
              d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
              stroke="#e00b5b"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.4001 6.6001L6.6001 11.4001"
              stroke="#e00b5b"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.6001 6.6001L11.4001 11.4001"
              stroke="#e00b5b"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="bulk__action">
            <button
              :disabled="disabled"
              @click="bulkUploadCustomers"
              class="btn btn--primary btn--sm cr-pointer"
            >
              Create Bulk Statement
            </button>
          </div>
        </div>
        <div v-else class="bulk__text" style="position: relative" @drop="drop">
          <input
            type="file"
            name="fields[assetsFieldHandle][]"
            id="assetsFieldHandle"
            class="bulk__file_input"
            @change="onChange"
            ref="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
          <p class="bulk__title">Drag and drop file here</p>
          <p class="bulk__sub_title">
            Select a .xlsx document from your computer or simply drag and drop
            one here to upload it.
          </p>
          <div class="bulk__action">
            <button class="btn btn--primary btn--sm cr-pointer">
              Select a file
            </button>
          </div>
        </div>
      </div>
    </div>
    <extend-modal
      :toggle="toggleModal"
      v-if="showModal"
      :loading="submitting"
    >
      <div class="modal-body">
        <svg
          width="249"
          height="249"
          viewBox="0 0 249 249"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="124.1"
            cy="124.1"
            r="124.1"
            fill="#60CDA7"
            fill-opacity="0.1"
          />
          <circle
            cx="124.1"
            cy="124.099"
            r="102.79"
            fill="#60CDA7"
            fill-opacity="0.3"
          />
          <circle
            cx="123.473"
            cy="124.727"
            r="75.8389"
            fill="#60CDA7"
            fill-opacity="0.5"
          />
          <circle cx="123.473" cy="124.726" r="48.2611" fill="#60CDA7" />
          <path
            d="M120.315 133.973L111.721 125.418C111.672 125.369 111.632 125.31 111.605 125.245C111.579 125.181 111.565 125.111 111.565 125.041C111.565 124.972 111.579 124.902 111.605 124.838C111.632 124.773 111.672 124.714 111.721 124.665L113.891 122.491C114.098 122.283 114.433 122.283 114.641 122.491L120.299 128.121C120.506 128.328 120.843 128.326 121.051 128.118L133.553 115.483C133.76 115.273 134.098 115.273 134.308 115.481L136.48 117.655C136.687 117.862 136.687 118.198 136.482 118.405L122.861 132.163L122.864 132.165L121.068 133.973C120.86 134.18 120.523 134.18 120.315 133.973Z"
            fill="white"
          />
        </svg>

        <div class="boxed">
          <template>
            <div class="text-center boxed__content">
              <h2>
                Bulk Statement Created Succesfully
              </h2>
              <button
                  @click="toggleModal"
                  class="btn btn--primary btn--sm"
                  type="button"
              >
                Done
              </button>
            </div>
          </template>
        </div>
      </div>
    </extend-modal>
  </div>
</template>

<script>
import ExtendModal from "../../../../components/ExtendModal";
import Button from "@/components/button";

export default {
  metaInfo: {
    title: "Bulk Create vNUBAN"
  },
  components: {
    Button,
    ExtendModal
  },
  data() {
    return {
      bulkFile: {
        url: "",
        filename: "",
        file: ""
      },
      vnuban: "",
      disabled: false,
      error: "",
      faultyItems: "",
      modalType: "bulk_vNuban_upload_success",
      showModal: false,
      submitting: false
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    hideModal() {
      this.closeModal = true;
      this.showModalContent = false;
    },
    bulkUploadCustomers() {
      if (this.bulkFile.file !== "") {
        this.disabled = true;

        let requestObject = new FormData();
        requestObject.append("files", this.bulkFile.file);
        requestObject.append("bank_code", "000017");

        this.$http
          .post("admin/statement/upload", requestObject)
          .then(response => {
            // Enable button
            this.disabled = false;
            if (response.body.data.error) {
              this.error = "Error";
              this.faultyItems = response.body.data.faulty_data;
              this.$notify({
                group: "notifications-default",
                type: "error text-white",
                title: "Error",
                text:
                  "An Error Occurred while trying to upload your bulk customers kindly make sure they match the provided format"
              });
            } else {
              // Notify user
              this.$notify({
                group: "notifications-default",
                type: "success text-white",
                title: "Success",
                text: "Your Statement Records are being proccessed"
              });

              this.closeModal = false;
              this.showModalContent = true;
              this.bulkFile.filename = "";
              this.toggleModal();
            }
          })
          .catch(error => {
            this.disabled = false;
            this.$notify({
              group: "notifications-default",
              // type: "error text-white",
              title: "Error",
              text: error.body.message
            });
          });
      }
    },
    downloadSample() {
      window.location.assign(
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vRR0x_QMa4cSPY961W0jX9BWpmnOwckb1pqChIavW_JLGnRk7dWDVSXYQ7_sdZCauOlTS6-FshjftHp/pub?output=xlsx"
      );
    },

    resetData() {
      this.error = "";
      this.bulkFile = {
        url: "",
        filename: "",
        file: ""
      };
      this.vnuban = "";
    },
    onChange() {
      this.bulkFile.file = this.$refs.file.files[0];
      this.bulkFile.filename = this.$refs.file.files[0]
        ? this.$refs.file.files[0].name
        : "";
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-body {
  margin: 0 auto;
  padding: 50px 150px;
  h2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
  }

  p {
    margin-bottom: 31px;
    color: #616e7c;
  }

  svg {
    margin-bottom: 12px;
  }

  textarea {
    resize: none;
    height: 4rem;
  }

  .boxed {
    width: 80%;
    margin: 0.5rem auto 1.5rem;
    &__content {
      h2 {
        font-size: 1.2rem;
        font-weight: bold;
      }
      button {
        font-size: 14px;
        padding: 18px 24px !important;
        height: 50px !important;
      }
    }
    .form__flex__item,
    button {
      margin-left: 0;
      width: 100%;
    }

    .details__card__item {
      padding: 0 0 24px;
      border: none;
    }
  }
}

.bulk__page__content {
  .bulk__header_right {
    display: flex;
    justify-content: flex-end;

    p {
      color: #ff7176;
      margin-top: -50px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}

.bulk {
  position: relative;
  padding: 100px 0 100px;
  text-align: center;
  width: 32%;
  margin: 0 auto;

  &__file_input {
    position: absolute;
    overflow: hidden;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
  }

  &__file_input::before {
    position: absolute;
    background: none;
    content: "";
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
  }

  &__icon {
    margin-bottom: 25px;
  }

  &__action {
    margin-top: 30px;

    button {
      font-size: 14px;
      padding: 18px 24px !important;
      height: 50px !important;
    }
  }

  &__text {
    width: 100%;
    margin: 0 auto;

    .bulk__title {
      color: #7a153c;
      font-size: 20px;
      margin-top: -10px;
      margin-bottom: 10px;
    }

    .bulk__sub_title {
      color: #616e7c;
      font-size: 0.8rem;
      line-height: 20px;
    }

    &--2 {
      color: #e00b5b;
      cursor: pointer;
      font-size: 16px;
      margin-top: 30px;
    }
  }
}

.bulk__action {
  margin-top: 30px;

  button {
    padding: 10px 30px !important;
  }
}

.cr-pointer {
  cursor: pointer;
}

.faulty {
  padding: 45px 45px;
  &__header {
    font-size: 24px;
    color: red;
    margin-bottom: 25px;
  }
  &__content {
    &__row {
      display: flex;
      &__item {
        padding: 5px 0;
        &:first-child {
          width: 100px;
        }
      }
    }
  }
}
.newac {
  padding: 15px 45px 45px;
}

@media (max-width: 768px) {
  .bulk {
    width: 100%;

    &__text {
      width: 90%;
    }
  }
}
</style>
